import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from '@angular/platform-browser';
import { PreviewProduitComponent } from "src/app/shared/components/preview-produit/preview-produit.component";



@Component({
  selector: 'app-detail-entete-bareme',
  templateUrl: './detail-entete-bareme.component.html',
  styleUrls: ['./detail-entete-bareme.component.scss']
})
export class DetailEnteteBaremeComponent implements OnInit {

  @Input('selectedBareme') selectedBareme :any
  @Output() onUpdateBareme = new EventEmitter<any>();

  itemToSave: any = {};
  filiale_id:any
  user: any = {};
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  @Input('bareme_id') bareme_id: any;
  itemsFiliale: any;
  itemBareme:any= {};

  constructor(
    private authService: AuthService,
    public bsModalRef: BsModalRef,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('change: ',changes)
    if (changes.bareme_id.currentValue) {
      console.log('La valeur a changé de', changes.bareme_id.previousValue, 'à', changes.bareme_id.currentValue);
      
      setTimeout(() => {
        
        if(changes.bareme_id.currentValue){
          this.getItemBareme(changes.bareme_id.currentValue)
        }
        


      });
    }
  }


  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  

  getItemBareme(bareme_id) {

    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        id : bareme_id
      },
    };

    this.busyGet = this.restClient
      .post("bareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemBareme = res["items"][0]
     
         
          } else {
            this.itemBareme = {}
          }
        },
        (err) => {
          this.itemBareme = {}
         }
      );
  }
 


  ngOnInit() {

  }

}
